<template>
    <mobile-navbar v-if="$vuetify.breakpoint.mobile"/>
    <desktop-navbar v-else/>
</template>

<script>
    import DesktopNavbar from '@/components/DesktopNavbar'
    import MobileNavbar from '@/components/MobileNavbar'
    export default {
        components: { DesktopNavbar, MobileNavbar },
        data: () => ({
        }),
        computed: {
        },
        methods: {
            menuActionClick(route) {
                var newPath = '/'+route;
                if(this.$route.path != newPath){
                    this.$router.push({path: newPath})
                }
            }
        }
    }
</script>
